/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { VideoEditorDeleteEditsMutationResponse, VideoEditorDeleteEditsPathParams, VideoEditorDeleteEdits401, VideoEditorDeleteEdits403 } from "../models/VideoEditorDeleteEdits";

export function getVideoEditorDeleteEditsUrl(id: VideoEditorDeleteEditsPathParams["id"]) {
  const res = { method: 'DELETE', url: `/video-editor/v1/edits/${id}` as const }
  return res
}

/**
 * @summary Delete a project
 * {@link /video-editor/v1/edits/:id}
 */
export async function videoEditorDeleteEdits(id: VideoEditorDeleteEditsPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<VideoEditorDeleteEditsMutationResponse, ResponseErrorConfig<VideoEditorDeleteEdits401 | VideoEditorDeleteEdits403>, unknown>({ method : "DELETE", url : getVideoEditorDeleteEditsUrl(id).url.toString(), ... requestConfig })
  return res.data
}